import {
  allAllowedToChoosePassportDocumentTypeCodes,
  allowedToChooseAddressRegDocumentTypeCodes,
} from '@/components/Forms/constants';

import { SERVICE_CODES } from '@/lib/consts';

export const SERVICE_CODE = SERVICE_CODES.RESIDENCE_RELOCATION;
export const STEP_NUMBER_DATA_PREVIEW = 6;
export const STEP_NUMBER_SIGN_UP = 7;

export const disallowedDocumentTypeCodesForAdditionalDocumentStep = [
  ...allAllowedToChoosePassportDocumentTypeCodes,
  ...allowedToChooseAddressRegDocumentTypeCodes,
];
